export const REQUIRED_COLUMNS = [
  "Scenario",
  "Categories",
  "Custom ID"
]

export const OPTIONAL_COLUMNS = [
  "Owner",
  "Identified Date",
  "Modified Date",
  "CIA Categories",
  "Inherent Risk",
  "Residual Risk",
  "Notes",
  "Treatment Type",
  "Tasks",
  "Approved",
  "Archived",
  "Vendors"
]

export const COL_TOOLTIP_MAP = {
  "Scenario": "ABCD",
  "Categories": "ABCD",
  "Custom ID": "ABCD",
  "Owner": "ABCD",
  "Identified Date": "ABCD",
  "Modified Date": "ABCD",
  "CIA Categories": "ABCD",
  "Inherent Risk": "ABCD",
  "Residual Risk": "ABCD",
  "Notes": "ABCD",
  "Treatment Type": "ABCD",
  "Tasks": "ABCD",
  "Approved": "ABCD",
  "Archived": "ABCD",
  "Vendors": "ABCD",
}